import React, {useState} from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import {useLocation} from 'react-router-dom';

const Nav = () => {
    const {pathname, hash} = useLocation();
    const [open, setOpen] = useState(false);
    return(
        <StyledNav>
            <h1 id="logo"><Link to="/#home">Nicolas d.</Link></h1>
            <Burger onClick={() => setOpen(!open)}>
                <span></span>
                <span></span>
                <span></span>
            </Burger>
            <NavLinks open={open}>
                <li>
                    <Link to="/#about" onClick={() => setOpen(false)}>A propos</Link>
                    <Line transition={{duration: .75}} initial={{width: '0%'}} animate={{width: hash === '#about' ? '50%' : '0%'}}/>
                </li>
                <li>
                    <Link to="/#tarifs" onClick={() => setOpen(false)}>Prestations & Tarifs</Link>
                    <Line transition={{duration: .75}} initial={{width: '0%'}} animate={{width: hash === '#tarifs' ? '50%' : '0%'}}/>
                </li>
                <li>
                    <Link to="/#infos" onClick={() => setOpen(false)}>Adresse</Link>
                    <Line transition={{duration: .75}} initial={{width: '0%'}} animate={{width: hash === '#infos' ? '50%' : '0%'}}/>
                </li>
                <li>
                    <Link to="products" onClick={() => setOpen(false)}>Produits</Link>
                    <Line transition={{duration: .75}} initial={{width: '0%'}} animate={{width: pathname === '/products' ? '50%' : '0%'}}/>
                    </li>
                <li>
                    <Link to="gallery" onClick={() => setOpen(false)}>Galerie</Link>
                    <Line transition={{duration: .75}} initial={{width: '0%'}} animate={{width: pathname === '/gallery' ? '50%' : '0%'}}/>
                    </li>
                <li>
                    <MobileBtn><Link to="reservation" onClick={() => setOpen(false)}>Réservation</Link></MobileBtn></li>
            </NavLinks>
            <Btn><Link to="reservation">Réservation</Link></Btn>
        </StyledNav>
    )
}

const StyledNav = styled.nav`
    min-height: 7vh;
    display: flex;
    margin: auto;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    position: sticky;
    padding: 0 10rem;
    background: rgba(255,255,255,.8);
    backdrop-filter: blur(10px);
    top: 0;
    z-index: 10;

    a{
        color: black;
        text-decoration: none;
    }

    #logo{
        font-size: 2rem;
        font-weight: lighter;
        font-family: "BrushScriptMTItalic", cursive;
    }
    
    li{
        padding: 0.4rem 2rem;
        position: relative;
        justify-content: center;
        text-align: center;
        font-weight: 500;
        font-size: 1rem;
    }

    @media (max-width: 768px){
        padding: 0.5rem 3rem;
        #logo{
            font-size: 4rem;
        }
    }
`;

const Burger = styled.div`
    display: none;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
    height: 2rem;
    width: 2.5rem;
    z-index: 20;
    span {
        height: 3px;
        width: 100%;
        background: #333;
        margin-bottom: 6px;
        border-radius: 2px;
        transition: all 0.3s;
    }
    @media (max-width: 768px){
        display: flex;
    }

`

const NavLinks = styled.ul`
    display: flex;
    list-style: none;
    padding: 0 5rem;
    align-items: center;

    @media (max-width: 768px){
        flex-direction: column;
        background: rgba(255,255,255,0.98);
        position: fixed;
        top: 0;
        right: 0;
        height: 100vh;
        width: 100%;
        padding: 5rem 2rem 2rem 2rem;
        z-index: 15;
        display: ${({ open }) => open ? 'flex' : 'none'};
        transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
        transition: transform 0.3s ease-in-out;
        box-shadow: ${({ open }) => open ? '-2px 0 10px rgba(0,0,0,0.1)' : 'none'};
        li {
            padding: 1.5rem 0;
            font-size: 1.3rem;
        }
        .desktop-btn {
            display: none;
        }
        .mobile-btn {
            display: none;
        }
    }
`

const Btn = styled.button`
    padding: .3rem 1rem;
    font-size: .8rem;
    background: #6190e8;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    a{
        color: white;
    }

    @media (max-width: 768px){
        display: none;
    }
`

const MobileBtn = styled.button`
    display: none;

    @media (max-width: 768px){
        display: block;
        a{
            color: white;
        }
        margin-top: 10rem;
        padding: 1rem 1rem;
        font-size: 1.5rem;
        background: #6190e8;
        border: none;
        border-radius: 5px;
    }
`
const Line = styled(motion.div)`
    height: .3rem;
    background: #6190e8;
    width: 0%;
    bottom: -20%;
    position: absolute;
    @media (max-width: 1000px){
        left: 0%;
    }
`

export default Nav;